import React, { useState, useEffect, useMemo } from "react";
import Header from "../../components/ui/Header";
import Button from "../../components/ui/Button";
import Icon from "../../components/AppIcon";

import UserCarsTable from "./components/UserCarsTable";
import UserCarsFormModal from "./components/UserCarsFormModal";
import UserCarsViewModal from "./components/UserCarsViewModal";
import DeleteConfirmModal from "../users-crud-management/components/DeleteConfirmModal";

import { useDispatch, useSelector } from "react-redux";
import {
  createCarTypesService,
  deleteCarTypesService,
  getCarTypesService,
  updateCarTypesService,
} from "redux/services/general_service";
import { toast } from "react-toastify";

const CarTypeManagment = () => {
  const dispatch = useDispatch();
  const { carTypesList, metaCarType } = useSelector((state) => state.general);

  const [page, setPage] = useState(1);

  const [language, setLanguage] = useState("ar");
  const [searchQuery, setSearchQuery] = useState("");
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [formMode, setFormMode] = useState("add");

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "ar";
    setLanguage(savedLanguage);
    dispatch(getCarTypesService({ page: 1 }));
  }, [dispatch, page]);

  const labels = {
    title: {
      en: "Car Brands",
      ar: " أنواع السيارات",
    },
    addNew: { en: "Add New Brand ", ar: "إضافة   نوع" },
    search: { en: "Search car Brand...", ar: "البحث عن نوع ..." },
    noResults: {
      en: "No car Brands",
      ar: "لم يتم العثور على  أنواع سيارات",
    },
  };

  /* 🔹 تهيئة الداتا القادمة من الـ API */
  const normalizedData = useMemo(() => {
    return (
      carTypesList?.map((v) => ({
        id: v.id,
        user: `${v.owner?.first_name || ""} ${v.owner?.last_name || ""}`,
        carType: v.vehicle_brand?.name,
        model: v.vehicle_model,
        year: v.vehicle_year,
        licensePlate: v.vehicle_number,
        color: v.vehicle_color,
        notes: v.notes,
        brandImage: v.vehicle_brand?.image?.media_link,
        raw: v, // نحتفظ بالعنصر الأصلي لو احتجناه
      })) || []
    );
  }, [carTypesList]);

  const filteredData = normalizedData.filter(
    (item) =>
      item.user?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.carType?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.model?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.licensePlate?.toLowerCase().includes(searchQuery.toLowerCase()),
  );
  const handleSave = (data) => {
    console.log("DATA TO SEND:", data);

    if (formMode === "add") {
      dispatch(createCarTypesService(data));
    } else {
      dispatch(updateCarTypesService({ id: selectedItem.id, data: data }));
    }

    setIsFormModalOpen(false);
  };
  return (
    <div className="min-h-screen bg-background">
      <Header />

      <div className="container mx-auto px-4 py-6 md:py-8">
        <div className="bg-card rounded-xl shadow-elevation-2 border border-border overflow-hidden">
          {/* Header */}
          <div className="px-4 py-4 md:px-6 md:py-6 border-b border-border">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="p-3 rounded-lg bg-primary/10">
                  <Icon name="Car" size={24} className="text-primary" />
                </div>
                <div>
                  <h1 className="text-xl md:text-2xl font-bold">
                    {labels.title[language]}
                  </h1>
                </div>
              </div>

              <Button
                onClick={() => {
                  setFormMode("add");
                  setSelectedItem(null);
                  setIsFormModalOpen(true);
                }}
                iconName="Plus"
              >
                {labels.addNew[language]}
              </Button>
            </div>
          </div>

          {/* Search */}
          <div className="px-4 py-4 md:px-6 border-b border-border">
            <div className="relative">
              <Icon
                name="Search"
                size={18}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
              />
              <input
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder={labels.search[language]}
                className="w-full pl-10 pr-4 py-2 rounded-lg border border-border"
              />
            </div>
          </div>

          {/* Table */}
          {filteredData.length === 0 ? (
            <div className="py-16 text-center">
              <Icon
                name="Car"
                size={48}
                className="mx-auto text-muted-foreground mb-3"
              />
              <p>{labels.noResults[language]}</p>
            </div>
          ) : (
            <UserCarsTable
              data={carTypesList}
              meta={metaCarType}
              language={language}
              onPageChange={(p) => setPage(p)}
              onView={(item) => {
                setSelectedItem(item);
                setIsViewModalOpen(true);
              }}
              onEdit={(item) => {
                setSelectedItem(item);
                setFormMode("edit");
                setIsFormModalOpen(true);
              }}
              onDelete={(item) => {
                setSelectedItem(item);
                setIsDeleteModalOpen(true);
              }}
            />
          )}
        </div>
      </div>

      {/* Modals */}
      <UserCarsFormModal
        isOpen={isFormModalOpen}
        onClose={() => setIsFormModalOpen(false)}
        onSave={handleSave}
        item={selectedItem}
        mode={formMode}
        language={language}
      />

      <UserCarsViewModal
        isOpen={isViewModalOpen}
        onClose={() => setIsViewModalOpen(false)}
        item={selectedItem}
        language={language}
      />

      <DeleteConfirmModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={() => {
          dispatch(deleteCarTypesService(selectedItem?.id)).then((res) => {
            if (res?.payload?.status == 200) {
              toast("تم الحذف بنجاح !");
              dispatch(getCarTypesService());
              setIsDeleteModalOpen(false);
            }
          });
        }}
        itemName={selectedItem?.licensePlate}
        language={language}
      />
    </div>
  );
};

export default CarTypeManagment;
